import { Autocomplete, TextField } from '@mui/material';
import React, { useEffect } from 'react'
import { useState } from 'react';
import { useRecoilCallback, useRecoilState, useResetRecoilState, useSetRecoilState } from 'recoil';
import useCatchErrorApi from 'src/shared/hooks/useCatchErrorApi';
import InputLabelCustom from '../../../shared/components/forms/InputLabelCustom';
import AutocompleteSkeleton from '../../../shared/components/skeletons/AutocompleteSkeleton';
import { capitalizeWords, finderProfessionalByName } from '../../../shared/global/helpers';
import { daysAvailableState, filterSearchSelectedState, isChangeFormSearchState } from '../../state/atoms';
import { dayDefaultAvailableState } from '../calendars/state/atoms';
import { professionalsBySpecialityState,professionalsByServiceState, professionalsState } from './state/atoms';

const AutocompleteProfessionals = ({ size = "small", styles }) => {
    const { catchErrorApi } = useCatchErrorApi();
    const setIsChangeFormSearch = useSetRecoilState(isChangeFormSearchState);
    const [filterSearchSelected, setFilterSearchSelected] = useRecoilState(filterSearchSelectedState);
    const [professionals, setProfessionals] = useRecoilState(professionalsState);
    const [loading, setLoading] = useState(false);
    const resetDayDefaultAvailable = useResetRecoilState(dayDefaultAvailableState);
    const resetDaysAvailable = useResetRecoilState(daysAvailableState);

    const loadProfessionals = useRecoilCallback(({ snapshot }) => async () => {
        setLoading(true)
        try {
            let sucursalCode = filterSearchSelected.sucursalSelected.code;
            let especialidadCode = filterSearchSelected.specialitySelected.code;
            let modalidad = filterSearchSelected.modalidadSelected.tipo;
            // console.log("SUCURSAL CODE3 => ", sucursalCode );
            // console.log("ESPECIALIDAD CODE3 => ", especialidadCode );

            if(especialidadCode != null){
                let obj = {
                    codSpeciality: especialidadCode,
                    sucursalCode: sucursalCode,
                    modalidad: modalidad
                  };
                const professionalsFetch =  await snapshot.getPromise(professionalsByServiceState(obj));
                setProfessionals(professionalsFetch)
            }else{
            // const professionalsFetch = await snapshot.getPromise(professionalsBySpecialityState(filterSearchSelected.specialitySelected.value));
            // setProfessionals(professionalsFetch)
            }

        } catch (error) {
            catchErrorApi(error);
        } finally {
            setLoading(false)
        }
    }, [filterSearchSelected.specialitySelected.value]);

    useEffect(() => {
        loadProfessionals()

        return () => {
            loadProfessionals();
        }
    }, [loadProfessionals])

    if (loading) return <AutocompleteSkeleton />

    return (
        <> 
            <InputLabelCustom htmlFor="autocomplete-profesional" text="Nombre del especialista (Opcional)" style={{ ...styles.label }} />
            <Autocomplete
                style={{ ...styles.autocomplete }}
                size={size}
                id="autocomplete-profesional"
                options={professionals.map((option) => `${option.ptdNombre}`)}
                getOptionLabel={option => capitalizeWords(option) || null}
                value={filterSearchSelected.professionalSelected.value || null}
                noOptionsText="Sin resultados"
                onChange={(event, value, reason) => {
                    setIsChangeFormSearch(true);
                    resetDayDefaultAvailable();
                    resetDaysAvailable();
                    if (reason === 'clear') {
                        setFilterSearchSelected({
                            ...filterSearchSelected,
                            professionalSelected: {
                                ...filterSearchSelected.professionalSelected,
                                value: '',
                                code: null
                            }
                        });

                        return;
                    }

                    if (reason === 'selectOption') {
                        const finderProfessional = finderProfessionalByName(professionals, value);
                        setFilterSearchSelected({
                            ...filterSearchSelected,
                            professionalSelected: {
                                ...filterSearchSelected.professionalSelected,
                                value: value,
                                code: finderProfessional?.ptdRut
                            }
                        })
                    }
                }}
                renderInput={(params) => <TextField {...params} placeholder="Buscar" variant="outlined" />}
            />
        </>
    )
}

export default AutocompleteProfessionals